import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { ProductsConfigService } from '@approot/services';

@Pipe({
  name: 'strikeFormatter'
})
export class StrikeFormatterPipe implements PipeTransform {
  constructor(private productsConfigService: ProductsConfigService) {}
  transform(value: any, cross: string): any {
    if (value === '') {
      return '';
    }

    if (!cross) {
      return formatNumber(value, 'en', '4').replace(',', '');
    }
    const fmt = this.productsConfigService.decimalPlacesForCrossPipe(cross);
    return formatNumber(value, 'en', fmt).replace(',', '');
  }
}
